import VsLoader from "./VsLoader";
import VsModal from "./VsModal";
import VsTable from "./VsTable";
import VsPager from "./VsPager";
import VsMonthPicker from "./VsMonthPicker/Index";
import VsDatePicker from "./VsDatePicker/Index";
import VsTooltip from "./VsTooltip";
import VsNoChartData from "./VsNoChartData";

export default function (vueObject) {
  vueObject.component("VsLoader", VsLoader);
  vueObject.component("VsModal", VsModal);
  vueObject.component("VsTable", VsTable);
  vueObject.component("VsPager", VsPager);
  vueObject.component("VsMonthPicker", VsMonthPicker);
  vueObject.component("VsDatePicker", VsDatePicker);
  vueObject.component("VsTooltip", VsTooltip);
  vueObject.component("VsNoChartData", VsNoChartData);
}
